export default class LocationAdapter {
  constructor(location = window.location) {
    this.location = location;
  }

  get search() {
    return this.location.search;
  }

  get host() {
    return this.location.host;
  }

  get pathname() {
    return this.location.pathname;
  }

  get protocol() {
    return this.location.protocol;
  }

  static href(url) {
    window.location.href = url;
  }

  static reload() {
    window.location.reload();
  }
}
